import React from "react";
import { motion } from "framer-motion";
import { FaCode, FaLightbulb, FaUsers, FaRocket } from "react-icons/fa";

const About = () => {
  const features = [
    {
      icon: <FaCode />,
      title: "Full-Stack Development",
      description:
        "Expertise in Next.js, TypeScript, React, and modern web technologies with focus on e-commerce solutions.",
    },
    {
      icon: <FaLightbulb />,
      title: "AI & Machine Learning",
      description:
        "Experience with AI systems including Handwritten Text Recognition and computer vision applications.",
    },
    {
      icon: <FaUsers />,
      title: "Team Collaboration",
      description:
        "Proven ability to work effectively in team environments through academic projects and professional experience.",
    },
    {
      icon: <FaRocket />,
      title: "Innovation",
      description:
        "Passionate about creating innovative solutions and staying current with emerging technologies.",
    },
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <h2>About Me</h2>
          <p>Get to know me better</p>
        </motion.div>

        <div className="about-content">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="about-text"
          >
            <h3>Who I Am</h3>
            <p>
              I'm a full-stack software engineer with a Computer Science degree
              from the University at Buffalo, School of Engineering and Applied
              Sciences. I enjoy building products that connect solid backend
              architecture with intuitive frontend experiences.
            </p>
            <p>
              Most recently, I worked at QBittensorLab and Nickel5, where I
              delivered end-to-end features using React, Next.js, Python,
              Node.js, REST APIs, and Docker. My work ranged from platform
              development and bug fixing to deployment and production support.
            </p>
            <p>
              I focus on building reliable, maintainable systems, collaborating
              across teams, and turning complex product ideas into practical,
              user-ready software.
            </p>
            <p>
              I'm currently working toward the AWS Certified Developer
              certification to deepen my cloud development and deployment
              expertise.
            </p>
            <p>
              I am a U.S. citizen and open to relocation anywhere for the
              right opportunity.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="about-stats"
          >
            <div className="stat-item">
              <h4>1+</h4>
              <p>Years of Professional Experience</p>
            </div>
            <div className="stat-item">
              <h4>5+</h4>
              <p>Major Projects</p>
            </div>
            <div className="stat-item">
              <h4>8+</h4>
              <p>Programming Languages</p>
            </div>
            <div className="stat-item">
              <h4>100%</h4>
              <p>Project Completion</p>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="features-grid"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className="feature-card"
            >
              <div className="feature-icon">{feature.icon}</div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default About;
